import script from "./UploadFile.vue?vue&type=script&lang=tsx"
export * from "./UploadFile.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__